"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ActionProcessor {
    constructor() {
        this.ID_MAP_FIELD = 'id';
        this.DATE_MAP_FIELD = 'date';
    }
    encodeRequestData(action) {
        return {};
    }
    decodeResponseData(responseData) {
        if (Array.isArray(responseData)) {
            return {
                items: responseData.map((responseDataItem) => this.decodeResponseDataItem(responseDataItem)),
                total: responseData.length
            };
        }
        return this.decodeResponseDataItem(responseData);
    }
    decodeResponseDataItem(responseDataItem) {
        return {
            id: responseDataItem[this.ID_MAP_FIELD],
            meta: {
                date: new Date(responseDataItem[this.DATE_MAP_FIELD])
            }
        };
    }
}
exports.ActionProcessor = ActionProcessor;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWN0aW9uLnByb2Nlc3Nvci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9jZXNzb3JzL2FjdGlvbi5wcm9jZXNzb3IudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFHQTtJQUFBO1FBRXFCLGlCQUFZLEdBQUcsSUFBSSxDQUFDO1FBQ3BCLG1CQUFjLEdBQUcsTUFBTSxDQUFDO0lBeUI3QyxDQUFDO0lBdkJRLGlCQUFpQixDQUFDLE1BQWM7UUFDckMsT0FBTyxFQUFFLENBQUM7SUFDWixDQUFDO0lBRU0sa0JBQWtCLENBQUMsWUFBaUI7UUFDekMsSUFBSSxLQUFLLENBQUMsT0FBTyxDQUFDLFlBQVksQ0FBQyxFQUFFO1lBQy9CLE9BQU87Z0JBQ0wsS0FBSyxFQUFFLFlBQVksQ0FBQyxHQUFHLENBQUMsQ0FBQyxnQkFBcUIsRUFBRSxFQUFFLENBQUMsSUFBSSxDQUFDLHNCQUFzQixDQUFDLGdCQUFnQixDQUFDLENBQUM7Z0JBQ2pHLEtBQUssRUFBRSxZQUFZLENBQUMsTUFBTTthQUMzQixDQUFDO1NBQ0g7UUFDRCxPQUFPLElBQUksQ0FBQyxzQkFBc0IsQ0FBQyxZQUFZLENBQUMsQ0FBQztJQUNuRCxDQUFDO0lBRVMsc0JBQXNCLENBQUMsZ0JBQXFCO1FBQ3BELE9BQU87WUFDTCxFQUFFLEVBQUUsZ0JBQWdCLENBQUMsSUFBSSxDQUFDLFlBQVksQ0FBQztZQUN2QyxJQUFJLEVBQUU7Z0JBQ0osSUFBSSxFQUFFLElBQUksSUFBSSxDQUFDLGdCQUFnQixDQUFDLElBQUksQ0FBQyxjQUFjLENBQUMsQ0FBQzthQUN0RDtTQUNGLENBQUM7SUFDSixDQUFDO0NBRUY7QUE1QkQsMENBNEJDIn0=